import {
  requestType,
  succeedType,
  failedType,
  AUTHENTICATE_APPLICATION,
  AUTHENTICATE_USER,
  LOGIN,
  LOGOUT,
  REQUIRE_OTP,
} from "./actionTypes";
import Axios from "axios";
import history from "./../helpers/history";
import forge from "node-forge";
import { showAlert } from "./alertAction";

export const authenticateApplication = (redirect, app_salt) => (dispatch) => {
  dispatch({ type: requestType(AUTHENTICATE_APPLICATION) });

  return Axios({
    method: "GET",
    url: `${process.env.REACT_APP_API_URL}/api/v1/application/search/?app_secret=${app_salt}`,
  })
    .then((res) => {
      if (res.status === 200) {
        dispatch({
          type: succeedType(AUTHENTICATE_APPLICATION),
          authenticated_app: res.data.data,
        });
      }
    })
    .catch((err) => {
      dispatch({ type: failedType(AUTHENTICATE_APPLICATION) });
      history.push("/404");
    });
};

export const authenticateUser = (app_salt, sid, url) => (dispatch) => {
  dispatch({ type: requestType(AUTHENTICATE_USER) });

  return Axios({
    method: "GET",
    url: `${process.env.REACT_APP_API_URL}/api/v1/user/authenticate?app_salt=${app_salt}&session_id=${sid}`,
  })
    .then((res) => {
      if (res.status === 200) {
        const { access_token, user_name, full_name, required_update_password } =
          res.data.data;
        dispatch({
          type: succeedType(AUTHENTICATE_USER),
          access_token,
          user_name,
          full_name,
          required_update_password,
        });
      }
    })
    .catch((err) => {
      dispatch({ type: failedType(AUTHENTICATE_USER) });
      history.push(`/login?redirect=${url}&salt=${app_salt}`);
    });
};

export const login = (redirect, app_salt, email, password) => (dispatch) => {
  dispatch({ type: requestType(LOGIN) });

  let hmac = forge.hmac.create();
  hmac.start("sha256", email);
  hmac.update(password);

  return Axios({
    method: "POST",
    url: `${process.env.REACT_APP_API_URL}/api/v1/user/login?app_salt=${app_salt}&redirect_url=${redirect}`,
    data: {
      email: email,
      password: hmac.digest().toHex(),
    },
  })
    .then((res) => {
      if (res.status === 200) {
        const { session_id, app_salt, redirect_url, required_update_password } =
          res.data.data;
        dispatch({ type: succeedType(LOGIN) });
        if (required_update_password) {
          history.push(
            `/change-password?sid=${session_id}&salt=${app_salt}&redirect_url=${redirect_url}`
          );
        } else {
          app_salt === process.env.REACT_APP_SSO_SALT
            ? history.push(`/?sid=${session_id}&salt=${app_salt}`)
            : window.location.assign(
                `${redirect_url}?salt=${app_salt}&sid=${session_id}`
              );
        }
      }
    })
    .catch((err) => {
      if (err.response.status === 403) {
        if (err.response.data.data) {
          if (err.response.data.data.policy_check_level === 1) {
            dispatch({ type: failedType(LOGIN) });
            dispatch(
              showAlert(err.response ? err.response.data.message : err.response)
            );
          }

          if (err.response.data.data.policy_check_level === 2) {
            dispatch({ type: failedType(LOGIN) });
            dispatch({ type: REQUIRE_OTP });
            // dispatch(showAlert(err.response ? err.response.data.message : err.response));
            history.push({
              pathname: "/otp",
              state: {
                email: email,
                app_salt: app_salt,
              },
            });
          }

          if (err.response.data.data.policy_check_level === 3) {
            dispatch({ type: failedType(LOGIN) });
            dispatch(
              showAlert(err.response ? err.response.data.message : err.response)
            );
            history.push(`/reset-password-request/${app_salt}`);
          }
        } else {
          dispatch({ type: failedType(LOGIN) });
          dispatch(
            showAlert(err.response ? err.response.data.message : err.response)
          );
        }
      } else {
        dispatch({ type: failedType(LOGIN) });
        dispatch(
          showAlert(err.response ? err.response.data.message : err.response)
        );
      }
    });
};

export const logout = (token) => (dispatch) => {
  dispatch({ type: requestType(LOGOUT) });

  return Axios({
    method: "POST",
    url: `${process.env.REACT_APP_API_URL}/api/v1/user/logout`,
    headers: {
      Authorization: token,
    },
  })
    .then((res) => {
      if (res.status === 200) {
        const { app_salt, redirect_url } = res.data.data;
        localStorage.removeItem("sid");
        localStorage.removeItem("salt");
        window.location.assign(
          `${process.env.REACT_APP_LOCAL}/login?redirect=${redirect_url}&salt=${app_salt}`
        );
      }
    })
    .catch((err) => {
      dispatch({ type: failedType(LOGOUT) });
      dispatch(
        showAlert(err.response ? err.response.data.message : err.response)
      );
    });
};
